export default "__VITE_ASSET__6YJCwHsQ__"